



























































































































import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import { Component, Prop } from 'vue-property-decorator';
import UUIFComponent from '@/shared/uuifComponent';
@Component({
  components:{
    ...UUIFComponent,
  },
})
export default class ProductsFreetrialCard extends SwExtendedVue{
  iconColor:string = '#FF791A1';
  ischecked:boolean = false;
  @Prop()
  widget:any;
  toggleCheckmark(value:boolean) {
    this.ischecked = !this.ischecked;
    if (value) { // value is true increment defcon and  shield value
      this.$emit('onChangeShields',  {
        defconValues:this.widget.defcon,
        shieldValues:this.widget.shieldLevel,
        mode:'increment',
      });
    } else { // value is false decrement defcon and  shield value
      this.$emit('onChangeShields', {
        defconValues:this.widget.defcon,
        shieldValues:this.widget.shieldLevel,
        mode:'decrement',
      });
    }
  }
  startTrial() {
    this.$emit('startTrial', { productID: this.widget.productID, serviceId:this.widget.serviceId, subDomain:this.widget.subDomain, widgetTitle: this.widget.softwareWidgetTitle });
  }
}
